module.exports = __webpack_public_path__ + "img/默认封面图.65911920.jpg";